import { ChangeEvent, useRef } from 'react'
import { Icon, SlimButton } from 'components'
import * as S from './styles'
import { fileTypes } from 'commons/utils/file'

interface TopBarProps {
  onFileSelect: (event: ChangeEvent<HTMLInputElement>) => void
  onDownloadClick: () => void
  onTrackingClick: () => void
  disabled?: boolean
}

const ICON_SIZE = '16'

export const TopBar = ({
  onFileSelect,
  onDownloadClick,
  onTrackingClick,
  disabled = false
}: TopBarProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const handleUploadClick = () => {
    if (fileInputRef.current !== null) {
      fileInputRef.current.click()
    }
  }

  return (
    <S.Container>
      <S.FileInput
        data-testid="upload-input"
        type="file"
        accept={fileTypes.Excel}
        onChange={onFileSelect}
        ref={fileInputRef}
      />
      <SlimButton
        data-testid="upload-button"
        variant="ghost"
        content="Upload"
        icon={<Icon icon="upload" size={ICON_SIZE} />}
        onClick={handleUploadClick}
        disabled={disabled}
      />
      <SlimButton
        data-testid="download-button"
        variant="ghost"
        content="Baixar"
        icon={<Icon icon="download" size={ICON_SIZE} />}
        onClick={onDownloadClick}
        disabled={disabled}
      />
      <SlimButton
        data-testid="tracking-button"
        variant="ghost"
        content="Tracking"
        icon={<Icon icon="track" size={ICON_SIZE} />}
        onClick={onTrackingClick}
        disabled={disabled}
      />
    </S.Container>
  )
}
